module.exports = __webpack_public_path__ + "img/b88fc06.png";